import React, { FC } from 'react'
import { getFeaturedStories } from '../selectors'
import { useSelector } from 'react-redux'
import styles from './Homepage.module.scss'
import GridLayout from 'components/SA/GridPosts/GridPosts'

const FeaturedStories: FC = () => {
  const featuredStories = useSelector(getFeaturedStories)
  const transFormedData = featuredStories.map((item) => {
    const { description, linkText, linkUrl, thumbnailImageUrl, title } = item

    return {
      image: thumbnailImageUrl,
      title: title,
      linkTitle: linkText,
      linkUrl: linkUrl,
      description: description,
    }
  })

  return (
    <div className={styles.featuredStories}>
      <GridLayout
        data={transFormedData}
        title='Art Collecting Made Simple'
        link='/stories'
        linkTitle='View All'
      />
    </div>
  )
}

export default FeaturedStories
